var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.has_position)?_c('GmapMarker',{attrs:{"position":_vm.position,"clickable":false,"draggable":false,"icon":_vm.icon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }